/* tslint:disable */
/* eslint-disable */
/**
 * Track API
 * The Track API provides access to SPiDRs and Security Focuses.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { TaskPriorityFromJSON, TaskPriorityToJSON, } from './TaskPriority';
import { TaskTypeFromJSON, TaskTypeToJSON, } from './TaskType';
/**
 * Check if a given object implements the TaskUpdateInput interface.
 */
export function instanceOfTaskUpdateInput(value) {
    let isInstance = true;
    return isInstance;
}
export function TaskUpdateInputFromJSON(json) {
    return TaskUpdateInputFromJSONTyped(json, false);
}
export function TaskUpdateInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'title': !exists(json, 'title') ? undefined : json['title'],
        'type': !exists(json, 'type') ? undefined : TaskTypeFromJSON(json['type']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'priority': !exists(json, 'priority') ? undefined : TaskPriorityFromJSON(json['priority']),
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
    };
}
export function TaskUpdateInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'title': value.title,
        'type': TaskTypeToJSON(value.type),
        'description': value.description,
        'priority': TaskPriorityToJSON(value.priority),
        'metadata': value.metadata,
    };
}
